import React, { useReducer } from 'react';
import { Button } from '@mui/material';
import styled from 'styled-components';

import ApplicationBar from 'components/ApplicationBar';
import Paper from 'components/Paper';
import Progress from 'components/Progress';
import { reducer } from 'state';
import { NewTemplate as INewTemplate, newTemplate } from 'types/Template';
import Preview from './preview';
import TemplateForm from './TemplateForm';

const StyledButtons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;

  margin: 1rem;

  & > *:not(:last-child) {
    margin-right: 1rem;
  }
`;

const StyledPaper = styled(Paper)`
  & > *:not(:last-child) {
    margin-bottom: 1rem;
  }
`;

const StyledNewTemplate = styled.div`
  position: relative;

  display: flex;
  flex-direction: row;

  margin: 1rem;

  & > :first-child {
    flex-grow: 1;
    margin-right: 1rem;
  }

  & > :last-child {
    width: 40%;
  }
`;

interface NewTemplateProps {
  saving: boolean;
  onCancel: () => void;
  onSave: (template: INewTemplate) => void;
}
const NewTemplate: React.FC<NewTemplateProps> = ({ saving, onCancel, onSave }) => {
  const [template, dispatch] = useReducer(reducer, newTemplate());

  return (
    <>
      {saving && <Progress />}

      <StyledButtons>
        <Button variant="contained" disabled={saving} onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="contained" color="primary" disabled={saving} onClick={() => onSave(template)}>
          Save
        </Button>
        <ApplicationBar showCollectionPicker={false} />
      </StyledButtons>

      <StyledNewTemplate>
        <TemplateForm template={template} dispatch={dispatch} />
        <StyledPaper>{template !== null && <Preview template={template} dispatch={dispatch} />}</StyledPaper>
      </StyledNewTemplate>
    </>
  );
};

export default NewTemplate;
